import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY;


export const getVisitasTotales = async (fechaInicio, fechaFin) => {
    try {
        const response = await api.get(`${urlApi}/exp-cliente/visitas-totales?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener las visitas totales:', error);
        throw error;
    }
}

export const getGraficaCliente = async (fechaInicio, fechaFin) => {
    try {
        const response = await api.get(`${urlApi}/exp-cliente/grafica-cliente?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener la gráfica del cliente:', error);
        throw error;
    }
}
export const getGraficaUltimaVisitaCliente = async (fechaInicio, fechaFin) => {
    try {
        const response = await api.get(`${urlApi}/exp-cliente/grafica-ultima-visita-cliente?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener la gráfica de la última visita del cliente:', error);
        throw error;
    }
}
export const getVisitasEjecutivos = async (fechaInicio, fechaFin) => {
    try {
        const response = await api.get(`${urlApi}/exp-cliente/visitas-ejecutivos?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener las visitas de los ejecutivos:', error);
        throw error;
    }
}
export const getVisitasInplant = async (fechaInicio, fechaFin) => {
    try {
        const response = await api.get(`${urlApi}/exp-cliente/visitas-inplant?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener las visitas inplant:', error);
        throw error;
    }
}
export const getVisitasZona = async (fechaInicio, fechaFin) => {
    try {
        const response = await api.get(`${urlApi}/exp-cliente/visitas-zona?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`);
        return response.data;
    }
    catch (error) {
        console.error('Error al obtener las visitas zona:', error);
        throw error;
    }
}